import React, { useState } from 'react';
import { Mail, X, Link2 } from 'lucide-react';

export default function ReceiptShareModal({
  isOpen,
  onClose,
  payment,
  defaultEmail = '',
  onShareEmail,
  onCopyLink,
}) {
  const [email, setEmail] = useState(defaultEmail);
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) return;

    setIsSending(true);
    try {
      await onShareEmail({ email: trimmedEmail, message: message.trim() });
      setMessage('');
      onClose();
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="vps-receipt-share-overlay" role="presentation" onClick={onClose}>
      <div
        className="vps-receipt-share-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="receipt-share-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="vps-receipt-share-header">
          <div className="vps-receipt-share-title-wrap">
            <Mail className="vps-receipt-share-icon" aria-hidden="true" />
            <h2 id="receipt-share-title">Share receipt</h2>
          </div>
          <button type="button" className="vps-receipt-share-close" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <p className="vps-receipt-share-lead">
          Email this receipt to your accountant, billing team, or anyone who needs a copy.
        </p>

        <form onSubmit={handleSubmit} className="vps-receipt-share-form">
          <label htmlFor="receipt-share-email">Recipient email</label>
          <input
            id="receipt-share-email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="name@company.com"
            required
            autoComplete="email"
          />

          <label htmlFor="receipt-share-message">Optional message</label>
          <textarea
            id="receipt-share-message"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="For your records…"
            rows={3}
            maxLength={1000}
          />

          <div className="vps-receipt-share-actions">
            <button
              type="button"
              className="vps-btn-link"
              onClick={onCopyLink}
            >
              <Link2 size={14} aria-hidden="true" />
              Copy receipt link
            </button>
            <div className="vps-receipt-share-actions-primary">
              <button type="button" className="vps-btn-link" onClick={onClose} disabled={isSending}>
                Cancel
              </button>
              <button type="submit" className="vps-btn-done vps-receipt-share-submit" disabled={isSending || !email.trim()}>
                {isSending ? 'Sending…' : 'Send receipt'}
              </button>
            </div>
          </div>
        </form>

        {payment?.customer_email && (
          <p className="vps-receipt-share-hint">
            Original receipt was sent to {payment.customer_email}.
          </p>
        )}
      </div>
    </div>
  );
}
